export type ThemeVariant = 'light' | 'dark' | 'auto';
export type NavPositionVariant = 'horizontal' | 'vertical' | 'combo' | 'dual';
export type NavTopShapeVariant = 'default' | 'slim';
export type NavbarAppearanceVariant = 'default' | 'darker';
export enum SupportedLanguage {
  en = 'en',
  fi = 'fi',
  ru = 'ru'
}

const getDefaultLanguage = (): SupportedLanguage => {
  const envLang = process.env.REACT_APP_DEFAULT_LANGUAGE;
  if (envLang && Object.values(SupportedLanguage).includes(envLang as SupportedLanguage)) {
    return envLang as SupportedLanguage;
  }
  return SupportedLanguage.en;
};

export interface Config {
  isNavbarVerticalCollapsed: boolean;
  openNavbarVertical: boolean;
  theme: ThemeVariant;
  navbarVerticalAppearance: NavbarAppearanceVariant;
  navbarTopAppearance: NavbarAppearanceVariant;
  navbarPosition: NavPositionVariant;
  navbarTopShape: NavTopShapeVariant;
  isRTL: boolean;
  isDark: boolean;
  bodyClass?: string;
  isChatWidgetVisible: boolean;
  language: SupportedLanguage;
  authorization: string | null;
  currentProjectId: number | null;
  lastBillingTab: 'Invoices' | 'Offers';
  taskListFormat: boolean;
  hourCardListFormat: boolean;
}

export const initialConfig: Config = {
  isNavbarVerticalCollapsed: false,
  openNavbarVertical: true, // for responsive
  theme: 'auto',
  navbarTopAppearance: 'default',
  navbarVerticalAppearance: 'default',
  navbarPosition: 'combo',
  navbarTopShape: 'default',
  isRTL: false,
  isDark: false,
  isChatWidgetVisible: false,
  language: getDefaultLanguage(),
  authorization: null,
  currentProjectId: null,
  lastBillingTab: 'Invoices',
  taskListFormat: false,
  hourCardListFormat: false
};
